/* eslint-disable import/prefer-default-export */

// angleToVector2D converts a angle in degrees to a 2D direction vector with an length multiplier
export const angleToVector2D = (angle: number, multiplier = 1): [number, number] => {
  return [Math.cos((angle * Math.PI) / 180) * multiplier, Math.sin((angle * Math.PI) / 180) * multiplier];
};
